import { render, staticRenderFns } from "./Streamax.vue?vue&type=template&id=3844e8bc&scoped=true&"
import script from "./Streamax.vue?vue&type=script&lang=ts&"
export * from "./Streamax.vue?vue&type=script&lang=ts&"
import style0 from "./Streamax.vue?vue&type=style&index=0&id=3844e8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3844e8bc",
  null
  
)

export default component.exports